import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "widget px-8 py-7 s20" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "text-red"
}

import { onMounted, reactive, ref } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import axios from 'axios';
    import OnboardingPersonalInfosForm from './OnboardingPersonalInfosForm.vue';
    import OnboardingIdentityDocumentsForm from './OnboardingIdentityDocumentsForm.vue';
    import OnboardingPayslipDocumentsForm from './OnboardingPayslipDocumentsForm.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingView',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const currentStepIndex = ref(1);
    const formParams = reactive({
        collectivites: [] as any[],
        types_piece_identites: [] as any[],
    });
    const formDatas = reactive({
        user: null as any,
        photo: null as any,
        type_piece_identite: null as any,
        numero_piece_identite: null as any,
        piece_recto: null as any,
        piece_verso: null as any,
        bulletin1: null as any,
        bulletin2: null as any,
        bulletin3: null as any,
    });
    onMounted(() => {
        const form_datas = route.meta.form_datas as { collectivites: any[], user: any, types_piece_identites: any[] };
        Object.assign(formParams, form_datas);
    });

    function goToStep(stepIndex: number) {
        currentStepIndex.value = stepIndex;
    }

    function onAccountCreated(user: any) {
        formDatas.user = user;
        goToStep(2);
    }

    function onIdentityDocumentsSaved(identityDocs: any) {
        formDatas.photo = identityDocs.photo;
        formDatas.type_piece_identite = identityDocs.type_piece_identite;
        formDatas.numero_piece_identite = identityDocs.numero_piece_identite;
        formDatas.piece_recto = identityDocs.piece_recto;
        formDatas.piece_verso = identityDocs.piece_verso;
        goToStep(3);
    }

    function onPayslipDocumentsSaved(payslipDocs: any) {
        formDatas.bulletin1 = payslipDocs.bulletin1;
        formDatas.bulletin2 = payslipDocs.bulletin2;
        formDatas.bulletin3 = payslipDocs.bulletin3;
        doSaveKYCDocuments();
    }

    function validate() {
        let isValid = true;
        if (!formDatas.user) {
            isValid = false;
        }
        if (!formDatas.photo) {
            isValid = false;
        }
        if (!formDatas.piece_recto) {
            isValid = false;
        }
        if (!formDatas.piece_verso) {
            isValid = false;
        }
        if (!formDatas.bulletin1) {
            isValid = false;
        }
        if (!formDatas.bulletin2) {
            isValid = false;
        }
        if (!formDatas.bulletin3) {
            isValid = false;
        }
        return isValid;
    }

    async function doSaveKYCDocuments() {
        if (!validate()) { return; }

        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = new FormData();
            formToUpload.append("nom", formDatas.user.nom);
            formToUpload.append("prenom", formDatas.user.prenom);
            formToUpload.append("date_naissance", formDatas.user.date_naissance);
            formToUpload.append("age", formDatas.user.age.toString());
            formToUpload.append("date_engagement", formDatas.user.date_engagement);
            formToUpload.append("anciennete", formDatas.user.anciennete.toString());
            formToUpload.append("collectivite_id", formDatas.user.collectivite_id.toString());
            formToUpload.append("salaire", formDatas.user.salaire);
            formToUpload.append("quotite_cessible_pourcent", formDatas.user.quotite_cessible_pourcent);
            formToUpload.append("quotite_cessible_montant", formDatas.user.quotite_cessible_montant);
            formToUpload.append("telephone", formDatas.user.telephone);
            formToUpload.append("email", formDatas.user.email);

            formToUpload.append("photo", formDatas.photo.file);
            formToUpload.append("type_piece_identite", formDatas.type_piece_identite);
            formToUpload.append("numero_piece_identite", formDatas.numero_piece_identite);
            formToUpload.append("piece_recto", formDatas.piece_recto.file);
            formToUpload.append("piece_verso", formDatas.piece_verso.file);
            formToUpload.append("bulletin1", formDatas.bulletin1.file);
            formToUpload.append("bulletin2", formDatas.bulletin2.file);
            formToUpload.append("bulletin3", formDatas.bulletin3.file);
            const response = await axios.post(`/backoffice/onboarding/create_account`, formToUpload);
            router.push(`/app/users/${response.data.user_id}`);
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(OnboardingPersonalInfosForm, {
          collectivites: formParams.collectivites,
          onSaved: onAccountCreated
        }, null, 8, ["collectivites"])
      ], 512), [
        [_vShow, currentStepIndex.value == 1]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        (formDatas.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(OnboardingIdentityDocumentsForm, {
                user: formDatas.user,
                types_piece_identites: formParams.types_piece_identites,
                onSaved: onIdentityDocumentsSaved
              }, null, 8, ["user", "types_piece_identites"])
            ]))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, currentStepIndex.value == 2]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        (formDatas.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(OnboardingPayslipDocumentsForm, {
                "form-params": { user: formDatas.user, photo: formDatas.photo },
                loading: loading.value,
                onSaved: onPayslipDocumentsSaved,
                onPrevious: _cache[0] || (_cache[0] = ($event: any) => (goToStep(2)))
              }, null, 8, ["form-params", "loading"])
            ]))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, currentStepIndex.value == 3]
      ]),
      (!!errorMessage.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
  ]))
}
}

})